import { render, staticRenderFns } from "./MedicalMain.vue?vue&type=template&id=1549d555&scoped=true&"
import script from "./MedicalMain.vue?vue&type=script&lang=js&"
export * from "./MedicalMain.vue?vue&type=script&lang=js&"
import style0 from "./MedicalMain.vue?vue&type=style&index=0&id=1549d555&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1549d555",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
